// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"UserLocationDropdown_scroll-black__Rw0V_","location":"UserLocationDropdown_location___GVpy","location-dropdown":"UserLocationDropdown_location-dropdown__VgWah"};